module.exports = __webpack_public_path__ + "img/FlangeAdapter.002b8b1a.png";